import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

/* MODAL */
import { useModal } from 'hooks/modalContext';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';
import ProductSearchForm from 'components/product/ProductSearchForm';

const Warehousing = () => {
  const { openModal } = useModal();

  const [productMstList, setProductMstList] = useState([{
    productSeq: 0,
    fkProductType: '',
    productType: '',
    fkProductKind: '',
    productKind: '',
    fkWarehouse: '',
    warehouse: '',
    productName: '',
    fkProductUnit: '',
    productUnit: '',
    productStatus: '',
    regDate: '',
    defaultQuantity: 0,
    currentQuantity: 0,
  }]);
  const [checkedList, setCheckedList] = useState([]);
  const [search, setSearch] = useState({
    productName: '',
    warehouseSeq: '',
    productTypeMstSeq: '',
    productKindSeq: '',
  });

  useEffect(() => {
    Common.isLogin();

    getProductMstList();
  }, []);

  const getProductMstList = () => {
    Server.sendGet('product/mst', search, getProductMstListCallback).then();
  };

  const getProductMstListCallback = res => {
    setProductMstList(res?.['resultList']);
  };

  const handleLabel = () => {
    if (!checkedList.length) return;

    const encodedArray = encodeURIComponent(JSON.stringify(checkedList));

    window.open(`/workforce/barcode?product=${encodedArray}`, 'popupWindow', 'width=873, height=600');
  };

  const handleAdd = () => {
    openModal({
      modalName: 'WarehousingModal',
      modalData: {
        isRegi: true,
        data: {
          item: {},
          callback: getProductMstList,
        },
      }
    });
  };

  const handleContent = item => {
    openModal({
      modalName: 'WarehousingModal',
      modalData: {
        isRegi: false,
        data: {
          item: item,
          callback: getProductMstList,
        },
      }
    });
  };

  const allCheckHandled = (checkThis) => {
    if (checkThis.checked) {
      setCheckedList([...checkedList, ...productMstList.filter(v => checkedList.filter(el => el.productSeq === v.productSeq).length === 0)]);
    } else {
      setCheckedList(checkedList.filter(v => productMstList.filter(el => el.productSeq === v.productSeq).length === 0));
    }
  };

  const multiCheckHandled = (checkThis, item) => {
    if (checkThis.checked) {
      setCheckedList([...checkedList, item]);
    } else {
      setCheckedList(checkedList.filter(el => el.productSeq !== item.productSeq));
    }
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Status of warehousing</h4>
          </TitHead>
          <BtnDesc>
            <TitBtn onClick={handleLabel}>
              <Ic src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/add_ic.svg'/>
              <span>Label print</span>
            </TitBtn>
            <TitBtn onClick={handleAdd}>
              <Ic src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/add_ic.svg'/>
              <span>Product warehousing</span>
            </TitBtn>
          </BtnDesc>
        </Title>
        <ProductSearchForm
          search={search}
          setSearch={setSearch}
          getList={getProductMstList}
        />
        <Content>
          <Table>
            <colgroup>
              <col width='5%'/>
              <col width='10%'/>
              <col width='10%'/>
              <col width='15%'/>
              <col width='15%'/>
              <col width='8%'/>
              <col width='9%'/>
              <col width='8%'/>
              <col width='12%'/>
              <col width='8%'/>
            </colgroup>
            <thead>
            <tr>
              <th>
                <SelectChk
                  type='checkbox'
                  checked={productMstList.filter(v => checkedList.filter(el => el.productSeq === v.productSeq).length !== 0).length === productMstList.length || false}
                  onChange={e => allCheckHandled(e.target)}
                />
              </th>
              <th>Warehouse</th>
              <th>Product Type</th>
              <th>Product Kind</th>
              <th>Product Name</th>
              <th>Quantity</th>
              <th>Current Quantity</th>
              <th>Unit</th>
              <th>Date of warehousing</th>
              <th>Detail</th>
            </tr>
            </thead>
            <tbody>
            {productMstList?.map((item, idx) => (
              <tr key={idx}>
                <td>
                  <SelectChk
                    type='checkbox'
                    checked={checkedList?.find(e => e?.productSeq === item?.productSeq) || false}
                    onChange={e => multiCheckHandled(e.target, item)}
                  />
                </td>
                <td>{item.warehouse}</td>
                <td>{item.productType}</td>
                <td>{item.productKind}</td>
                <td>{item.productName}</td>
                <td>{item.defaultQuantity}</td>
                <td className={`${item.defaultQuantity !== item.currentQuantity ? 'warning' : ''}`}>{item.currentQuantity}</td>
                <td>{item.productUnit}</td>
                <td>{item.regDate}</td>
                <td>
                  <TitBtn onClick={() => handleContent(item)}>
                    <span>Detail</span>
                  </TitBtn>
                </td>
              </tr>
            ))}
            {Common.isEmpty(productMstList) &&
              <tr>
                <td colSpan={9} className={'none-data'}>
                  There is no data to output.
                </td>
              </tr>
            }
            </tbody>
          </Table>
        </Content>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const BtnDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

const Ic = styled.img.attrs({ alt: 'Util Icon' })``;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 622px;
  overflow-y: scroll;
`;

const Table = styled.table`
  position: relative;

  & th {
    padding: 15px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
    height: 47px;
  }

  .warning {
    background: yellow;
  }

  & thead {
    position: sticky;
    top: 0;
  }

  & tbody > tr {
    cursor: pointer;

    &:hover {
      & td {
        background: #f4f4f4;
      }
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

const SelectChk = styled.input`
  appearance: none;
  width: 36px;
  height: 36px;
  background: url(https://mendle-s3-bucket.s3.ap-northeast-2.amazonaws.com/beauty-book/bb/admin/admin_chkOff.svg) 50% 50% no-repeat;
  background-size: 24px 24px;

  &:checked {
    background: url(https://mendle-s3-bucket.s3.ap-northeast-2.amazonaws.com/beauty-book/bb/admin/admin_chkOn.svg) 50% 50% no-repeat;
  }
`;

export default Warehousing;
